import { createReducer, on } from '@ngrx/store';
import { defaultWalletListFilter } from '../../types/wallet-list-filter';
import {
  fetchSenderWalletList,
  loadedSenderWalletList,
  failedSenderWalletList,
  updateSenderWalletListFilter,
  resetSenderWalletList,
} from './sender-wallet-list.actions';
import {
  initialSenderWalletListState,
  SenderWalletListState,
  initialDataSource,
} from './sender-wallet-list.state';

export const senderWalletListReducer = createReducer(
  initialSenderWalletListState,
  on(fetchSenderWalletList, (state): SenderWalletListState => ({ ...state })),
  on(loadedSenderWalletList, (state, action): SenderWalletListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedSenderWalletList, (state): SenderWalletListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(
    updateSenderWalletListFilter,
    (state, { filter }): SenderWalletListState => {
      return {
        ...state,
        filter: { ...state.filter, ...(filter ?? defaultWalletListFilter) },
        dataSource: { ...state.dataSource },
      };
    }
  ),
  on(resetSenderWalletList, (state): SenderWalletListState => {
    return {
      ...state,
      filter: { ...defaultWalletListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
